import React, { useContext } from 'react';
import './DashboardLayout.css';
import dashboardContext from '../../../context/dashboard/dashboardContext';

const DashboardLayout = ({ children, title, subtitle, actions }) => {
  const { 
    selectedRestaurant, 
    restaurants, 
    autoRefresh, 
    toggleAutoRefresh, 
    refreshData,
    loading 
  } = useContext(dashboardContext);

  const currentRestaurant = restaurants.find(r => r.id === selectedRestaurant);

  return (
    <div className="dashboard-layout">
      <div className="dashboard-header">
        <div className="dashboard-header-left">
          <h1 className="dashboard-title">{title}</h1>
          {subtitle && <p className="dashboard-subtitle">{subtitle}</p>}
          {currentRestaurant && (
            <div className="restaurant-badge">
              <span className="restaurant-icon">🏪</span>
              <span className="restaurant-name">{currentRestaurant.name}</span>
              <span className="restaurant-location">{currentRestaurant.location}</span>
            </div>
          )}
        </div>

        <div className="dashboard-header-right">
          <div className="dashboard-controls">
            <button 
              className={`control-btn ${autoRefresh ? 'active' : ''}`}
              onClick={toggleAutoRefresh}
              title={autoRefresh ? 'Auto-refresh ON' : 'Auto-refresh OFF'}
            >
              <span className="control-icon">🔄</span>
              {autoRefresh ? 'Live' : 'Paused'}
            </button>

            <button 
              className="control-btn"
              onClick={refreshData}
              disabled={loading}
              title="Refresh data"
            >
              <span className={`control-icon ${loading ? 'spinning' : ''}`}>↻</span>
              Refresh
            </button>

            {actions}
          </div>
        </div>
      </div>

      {loading && (
        <div className="dashboard-loading-bar">
          <div className="loading-bar-fill"></div>
        </div>
      )}

      <div className="dashboard-content">
        {children}
      </div>
    </div>
  );
};

export default DashboardLayout;

